function makeChartLegend(anchor, data)
{
    var w = $(anchor).width(); //width
    var h = 300; //height
    var r = 150; //radius
    var rmid = r+100;
    var radius = r;
    var wOffSet = 100;
    var legendY = 50;
    var legendH = 100;
    var numberOfChars = 20;
    var legendSquare = 10;
    var legendOutSet = 75;
    var legendOutSet2 = 20;
    var legendTextOffSet = 40;
    var legendTextOffSetY = 5;
    var color = d3.scale.category20(); //builtin range of colors
    var total = 0;
    var i = 0;
    while (data[i])
    {
        if (data[i].sort==1)
        {
            total=total+data[i].number;
        }else
        {
            total=total+data[i].value;
        }
        i++;
    }

    var svg = d3.select(anchor)
        .append("svg:svg");
    var vis = svg //create the SVG element inside the <body>
        .data([data]) //associate our data with the document
        .attr("width", w) //set the width and height of our visualization (these will be attributes of the <svg> tag
        .attr("height", h)
        .append("svg:g") //make a group to hold our pie chart
        .attr("transform", "translate(" + rmid + "," + r + ")"); //move the center of the pie chart from 0, 0 to radius, radius



    var arc = d3.svg.arc() //this will create <path> elements for us using arc data
        .outerRadius(r-50);


    var pie = d3.layout.pie() //this will create arc data for us given a list of values
        .value(function (d)
        {
            if (d.sort==1)
            {
                return d.number;
            }else
            {
                return d.value;
            }

        }); //we must tell it out to access the value of each element in our data array

    var arcs = vis.selectAll("g.slice") //this selects all <g> elements with class slice (there aren't any yet)
        .data(pie) //associate the generated pie data (an array of arcs, each having startAngle, endAngle and value properties)
        .enter() //this will create <g> elements for every "extra" data element that should be associated with a selection. The result is creating a <g> for every object in the data array
        .append("svg:g") //create a group to hold each slice (we will have a <path> and a <text> element associated with each slice)
        .attr("class", "slice clickable"); //allow us to style things in the slices (like text)

    arcs.append("svg:path")
        .attr("fill", function (d, i)
        {
            return color(i);
        }) //set the color for each slice to be chosen from the color function defined above
        .attr("d", arc)
        .on('mouseover',function(d){
            d3.select(this)
                .attr('fill', "lightgrey");
        })
        .on('mouseout',function(d, i){
            d3.select(this)
                .attr("fill",color(i))
        }); //this creates the actual SVG path using the associated data (pie) with the arc drawing function
    d3.selectAll("g.slice").data(data)
        .attr("onclick", function (d)
        {
            return "window:location.href='"+d.link+"'";
        });

    //legend on the side of the chart
    var legend = svg.append("g")
        .attr("class", "legend")
        .attr("x", w - wOffSet)
        .attr("y", legendY)
        .attr("height", legendH)
        .attr("width", wOffSet)
        .attr('transform', 'translate(-60,13)');


    legend.selectAll('arc')
        .data(data)
        .enter()
        .append("rect")
        .attr("x", w - wOffSet)
        .attr("y", function(d, i)
        {
            return i * 20;
        })
        .attr("width", legendSquare)
        .attr("height", legendSquare)
        .attr("fill", function(d,i)
        {

            return color(i);
        });


    legend.selectAll('text')
        .data(data)
        .enter()
        .append("text")
        .attr("x", w - wOffSet + 13)
        .attr("y", function (d, i)

        {
            return i * 20 + 9;
        })
        .attr("class","clickable")
        .attr("onclick", function (d)
        {
            return "window:location.href='"+d.link+"'";
        })
        .text(function (d)
        {
            return d.label.substring(0,numberOfChars)+" (" + d.number +")";
        });


    //legend in the chart
    vis.selectAll("text").data(pie)
        .enter()
        .append("text")
        .attr("text-anchor", "middle")
        .attr("x", function(d,i)
        {
            //find the middle of each slice
            var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
            d.cx = Math.cos(a) * (radius - legendOutSet);
            var printString;
            if (data[0].sort==2)
            {
                printString=data[i].curr+" | "+Math.round(100*data[i].value/total)+" %";
            }
            else
            {
                printString=data[i].number+" "+data[i].unit+" | "+Math.round(100*data[i].number/total)+" %"
            }
            var xOffSet=(printString).length+5;
            if (data[0].sort==1)
            {
                // this condition is used to not print a legend to small slices which would overlap
                if ((data[i].number/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI))))
                {
                    if ((d.endAngle + d.startAngle)/2<Math.PI)
                    {
                        return Math.cos(a) * (radius - legendOutSet2)+xOffSet*3;
                    }else
                    {
                        return Math.cos(a) * (radius - legendOutSet2)-xOffSet*3;
                    }
                }
            }
            else
            {
                if ((data[i].value/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI))))
                {
                    if ((d.endAngle + d.startAngle)/2<Math.PI)
                    {
                        return Math.cos(a) * (radius - legendOutSet2)+xOffSet*3;
                    }else
                    {
                        return Math.cos(a) * (radius - legendOutSet2)-xOffSet*3;
                    }
                }
            }

        })
        .attr("y", function(d)
        {
            var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
            d.cy = Math.sin(a) * (radius - legendOutSet);
            return Math.sin(a) * (radius - legendOutSet2);
        })
        .text(function(d,i)
        {
            if (data[i].sort==2)
            {
                if ((data[i].value/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI)))){
                    return data[i].curr+" | "+Math.round(100*data[i].value/total)+" %";
                }
            }
            else
            {
                if ((data[i].number/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI)))){
                    return data[i].number+" "+data[i].unit+" | "+Math.round(100*data[i].number/total)+" %";
                }
            }

        });
    //print points
    vis.append("defs").append("marker")
        .attr("id", "circ")
        .attr("markerWidth", 6)
        .attr("markerHeight", 6)
        .attr("refX", 3)
        .attr("refY", 3)
        .append("circle")
        .attr("cx", 3)
        .attr("cy", 3)
        .attr("r", 2);
    //print lines
    vis.selectAll("path.pointer").data(pie).enter()
        .append("path")
        .attr("class", "pointer")
        .style("fill", "none")
        .attr("marker-end", "url(#circ)")
        .style("stroke", "black")
        .attr("x", function(d)
        {
            var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
            d.cx = Math.cos(a) * (radius - legendOutSet);
            return d.x = Math.cos(a) * (radius - legendOutSet2);
        })
        .attr("y", function(d)
        {
            var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
            d.cy = Math.sin(a) * (radius - legendOutSet);
            return d.y = Math.sin(a) * (radius - legendOutSet2);
        })
        .attr("d", function(d,i)
        {
            var limit =false;
            if (data[0].sort==1)
            {
                if ((data[i].number/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI)))){
                    limit=true;
                }
            }else
            {
                if ((data[i].value/total>0.03)&&((data[i].number/total>0.05)||(((d.startAngle+d.endAngle)/2)<(0.92*2*Math.PI)))){
                    limit=true;
                }
            }
            if (limit==true)
            {
                d.sx = d.x;
                d.ox = d.x + legendTextOffSet;
                d.lx = d.x - legendTextOffSet;
                d.sy = d.oy = d.y + legendTextOffSetY;
                if ((d.endAngle + d.startAngle)/2 <Math.PI)
                {
                    return "M" + d.ox + "," + d.sy + "L"  + d.sx + "," + d.sy + " " + d.cx + "," + d.cy;
                }else
                {
                    return "M" + d.lx + "," + d.sy + "L"  + d.sx + "," + d.sy + " " + d.cx + "," + d.cy;
                }
            }
        });
}

function makeBarChart(anchor, data) {

    var barData = data;
    var colors  = d3.scale.category20();
    var vis = d3.select(anchor);
    var WIDTH = $(anchor)[0].getBoundingClientRect().width;
    var HEIGHT = 300;
    var MARGINS = {
            top: 20,
            right: 20,
            bottom: 20,
            left: 50
        };
    var xRange = d3.scale.ordinal().rangeRoundBands([MARGINS.left, WIDTH - MARGINS.right], 0.1).domain(barData.map(function (d) {
            return d.x;
        }));


    var yRange = d3.scale.linear().range([HEIGHT - MARGINS.top, MARGINS.bottom]).domain([0,
            d3.max(barData, function (d) {
                return d.y;
            })
        ]);

    var xAxis = d3.svg.axis()
            .scale(xRange)
            .tickSize(5)
            .tickSubdivide(true);

    var yAxis = d3.svg.axis()
            .scale(yRange)
            .tickSize(1)
            .orient("left")
            .tickSubdivide(true);


    vis.append('svg:g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + (HEIGHT - MARGINS.bottom) + ')')
        .call(xAxis);

    vis.append('svg:g')
        .attr('class', 'y axis')
        .attr('transform', 'translate(' + (MARGINS.left) + ',0)')
        .call(yAxis);

    vis.selectAll('rect')
        .data(barData)
        .enter()
        .append('rect')
        .attr('x', function (d) {
            return xRange(d.x);
        })
        .attr('y', function (d) {
            return yRange(d.y);
        })
        .attr('width', xRange.rangeBand())
        .attr('height', function (d) {
            return ((HEIGHT - MARGINS.bottom) - yRange(d.y));
        })
        .attr("fill",function(d, i){return colors(i)})
        .attr("onclick", function (d)
        {
            return "window:location.href='"+d.link+"'";
        })
        .attr("class","clickable")
        .on('mouseover',function(d){
            d3.select(this)
                .attr('fill', "lightgrey");
        })
        .on('mouseout',function(d, i){
            d3.select(this)
                .attr("fill",colors(i))
        });

}